import { render, staticRenderFns } from "./RatingsSVG.vue?vue&type=template&id=14d857ae&"
import script from "./RatingsSVG.vue?vue&type=script&lang=js&"
export * from "./RatingsSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports